// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__4dahb","clinicsSelect":"TableHeading_clinicsSelect__2R1I8"};